import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user-service/user.service';
import { MatDialog } from '@angular/material';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { ApplicationUrlSettings } from '../settings/ApplicationUrlSettings';
import { environment } from '../../environments/environment';

@Component({
  selector: 'login-form',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  host: { 'class': 'user-login-page' }
  //styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  email;
  password;
  returnUrl = null;
  environment = environment;

  constructor(private router: Router, private route: ActivatedRoute, private usesService: UserService, private dialog: MatDialog) { }

  ngOnInit() {
    // Get the return URL from the query parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    var login = window.localStorage.getItem('login');
    if (login) {
      var info = JSON.parse(login);

      if (info.payload) {
        if (info.payload.employeeid) {

          this.router.navigate(['/user-portal/account']);

        }
      }
    }
    sessionStorage.removeItem('userData');
  }

  register() {
    this.router.navigate(['user/register']);
  }

  getDataUri() {
    `${ApplicationUrlSettings.NODE_API_URL}users/google-login`;
  }

  login() {


    this.usesService.loginUser(this.email, this.password).then((res: any) => {
      if (res.status) {
        window.localStorage.clear();
        window.localStorage.setItem("login", JSON.stringify(res.data));
        if (res.data.payload.email.includes('advantagecall.com')) {
          this.router.navigate(['/user-portal/profile'], { queryParams: { companyemail: 1 } });
        } else {
          if (this.returnUrl) {
            // Redirect to the original route after successful login
            this.router.navigateByUrl(this.returnUrl);
          } else {
            this.router.navigate(['/user-portal/account']);
          }
        }
      } else {

        new QuickDialog(this.dialog).InfoDialog("Please ensure your email and password is correct", "Login Failed", "OK");
      }
    }).catch(e => {
      console.log(e);
      if (e.status == 401) {
        new QuickDialog(this.dialog).InfoDialog("Please ensure your email and password is correct", "Login Failed", "OK");
      } else {
        new QuickDialog(this.dialog).InfoDialog("An Error Occured Please Try Again", "Login Failed", "OK");
      }

    });
  }

  resetPassword() {

    new QuickDialog(this.dialog).PromptDialog({
      title: "Resend Password Reset Link",
      msg: "Please enter the email address used when you registered. We will send you a link and you can reset your password from there.",
      cancelable: true
    }).then((email) => {
      if (email) {
        this.usesService.sendPasswordResetLink(email).then((result: any) => {

          if (result.status) {
            new QuickDialog(this.dialog).InfoDialog("A reset password link has been sent to the email you provided", "Check Your Email", "OK");
          } else {
            new QuickDialog(this.dialog).InfoDialog("There was an issue with your request, please try again", "Sorry", "OK");
          }

        }).catch(e => {

          new QuickDialog(this.dialog).InfoDialog("There was an issue with your request, please try again", "Sorry", "OK");
        })
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts